<template>
  <div>
    <list
      row-key="RecordId"
      ref="list"
      unit="单页介绍"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canDel()"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="内容标题">
          <el-input
            size="mini"
            v-model="params.NotesTitle"
            placeholder="请输入内容标题"
            clearable
          />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="NotesTitle" label="内容标题" align="center" />

        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
  <script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/sy/singlenotes").default,
      params: {
        //查询条件使用到的字段就需要写在这里
        NotesTitle: "",
      },
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>
  <style lang="scss">
.el-form-item .el-form-item__content .long-inp {
  width: 200px !important;
  .el-input__inner {
    width: 200px;
  }
}
</style>